<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>用户管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户开课管理列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>用户开课管理列表</span>
        </div>
        <div style="display: flex">
          <el-button @click="selectCourse()" size="small" icon="el-icon-plus" type="success">添加课程</el-button>
        </div>
      </div>
      <div class="search-box">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入手机号" v-model="searchs.mobile"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getSearchIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearSearchIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe size="small" style="width: 100%" v-loading="loading">
          <el-table-column align="center" prop="id" label="UID" width="80"></el-table-column>
          <el-table-column label="类型" width="78">
            <template #default="scope">
              <el-tag v-if="scope.row.is_pack == 2" type="success">套餐</el-tag>
              <el-tag v-else type="danger">课程</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="mobile" label="手机号/订单号" width="180"></el-table-column>
          <el-table-column prop="course_title" label="课程名称" width="*"></el-table-column>
          <el-table-column align="center" prop="vip_title" label="VIP类型" width="200">
            <template #default="scope">
              {{ scope.row.vip_title }}
              <el-tag size="mini" v-if="scope.row.is_plus == 1" type="danger">+ PLUS</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="etime" width="100" label="状态">
            <template #default="scope">
              <el-tag v-if="scope.row.status" type="success">已激活</el-tag>
              <el-tag v-else type="info">待激活</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="220">
            <template #default="scope">
              <el-button v-if="scope.row.status == 0" size="mini" type="success" icon="el-icon-time"
                @click="active_item(scope.row.id)">立即激活</el-button>
              <el-button v-else size="mini" type="info" icon="el-icon-circle-check">激活成功</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)" icon="el-icon-delete">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="total, prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 选择课程 -->
    <el-dialog title="选择套餐课程" top="9vh" @close="closeTableVisible" :close-on-click-modal="false" width="58%"
      :visible.sync="dialogTableVisible">
      <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline">
        <el-form-item label="手机号/订单号:" prop="mobile" label-width="120px">
          <el-input style="width: 500px;" type="textarea" v-model="formInline.mobile"
            placeholder="手机号/订单号(多个手机号请用+号隔开)"></el-input>
        </el-form-item>
        <el-form-item label="VIP会员:" prop="vip" label-width="120px">
          <el-select v-model="formInline.vip" placeholder="VIP会员" style="width: 120px;">
            <el-option label="会员权限" value="0"></el-option>
            <el-option label="季卡" value="90"></el-option>
            <el-option label="半年卡" value="180"></el-option>
            <el-option label="年卡" value="365"></el-option>
          </el-select>
          <el-checkbox v-model="formInline.is_plus" :true-label="1" :false-label="0"
            style="margin-left: 15px;">开通PLUS</el-checkbox>
        </el-form-item>
        <el-form-item label="科目:" prop="column_id" label-width="120px">
          <el-cascader style="width: 500px;"
            :props="{ label: 'title', 'value': 'id', 'children': 'childs', multiple: true }" placeholder="试试搜索：一建"
            filterable clearable v-model="formInline.column_ary" :options="LmColumn"
            @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="类型:" label-width="120px">
          <el-radio-group v-model="formInline.is_pack" @input="onChangeType($event)">
            <el-radio :label="1">课程</el-radio>
            <el-radio :label="2">套餐</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开通课程:" prop="course_id" label-width="120px">
          <el-input style="width: 500px;" v-model="formInline.course_id" disabled placeholder="请选择下面的课程"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('formInline')">确认添加</el-button>
          <el-button type="info" @click="submitClear()">清除信息</el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true">
        <el-form-item>
          <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="search.pattern_id" placeholder="全部套餐">
            <el-option label="全部套餐" :value="0"></el-option>
            <el-option v-for="item in pattern" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
        </el-form-item>
      </el-form>

      <el-table border size="mini" :data="gridData">
        <el-table-column label="分类" width="260">
          <template #default="scope">{{ scope.row.column_name }} - {{ scope.row.subject_name }}</template>
        </el-table-column>
        <el-table-column property="title" label="名称" width="*"></el-table-column>
        <el-table-column align="center" label="操作" width="90">
          <template #default="scope">
            <el-button v-if="scope.row.selected" size="mini" @click="deleteCourse(scope.row, scope.$index)" type="info"
              plain>取消</el-button>
            <el-button v-else size="mini" type="primary"
              @click="select_model_item(scope.row, scope.$index)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <el-pagination class="left" :page-size="pageSize" @current-change="handleCurrentChangeGrid"
          :current-page="pageGrid" background layout="total,prev, pager, next" :total="countGrid"></el-pagination>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      loading: true,
      tableData: [],
      pattern: [],
      page: 0,
      count: 0,
      limit: 8,
      uid: 0,
      course_ary: [],
      gridData: [],
      LmColumn: [],
      loading: true,
      pageGrid: 0,
      countGrid: 0,
      pageSize: 0,
      GirdUrl: "/getPageCourse",
      searchs: {
        mobile: "",
      },
      search: {
        type: "",
        keys: "",
        pattern_id: 0,
      },
      formInline: {
        mobile: "",
        vip: "90",
        column_id: "",
        column_ary: [],
        course_id: "",
        is_plus: 0,
        is_pack: 1,
      },
      rules: {
        mobile: [
          { required: true, message: "填写手机或订单号", trigger: "change" },
        ],
        column_id: [{ required: true, message: "选择科目", trigger: "change" }],
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var query = that.$route.query;
    if (query.uid) {
      that.uid = query.uid;
    }
    that.getList();
  },
  methods: {
    getSearchIndex() {
      var that = this;
      that.getList();
    },

    getClearSearchIndex() {
      this.searchs.mobile = "";
      this.getList();
    },

    selectCourse() {
      var that = this;
      that.dialogTableVisible = true;
      that.getColumn();
      that.getCoursePattern();
      that.getGridData();
    },

    getIndex() {
      var that = this;
      that.getGridData();
    },

    getClearIndex() {
      this.search.keys = "";
      this.search.type = "";
      this.search.pattern_id = "";
      this.getGridData();
    },

    select_model_item(ids, index) {
      var that = this;
      that.gridData[index].selected = 1;
      that.course_ary.push(ids.id);
      console.log(that.course_ary);
      that.formInline.course_id = that.course_ary.join(",");
      //that.setOpenCourse(ids);
    },

    deleteCourse(ids, index) {
      var that = this;
      that.gridData[index].selected = 0;
      that.course_ary.forEach((item, idx) => {
        if (item == ids.id) {
          that.course_ary.splice(idx, 1);
        }
      });
      that.formInline.course_id = that.course_ary.join(",");
    },

    handleCurrentChangeGrid(currentPage) {
      var that = this;
      that.pageGrid = currentPage;
      that.getGridData();
    },

    add() {
      this.$router.push("/admin/add");
    },

    closeTableVisible() {
      const that = this;
      that.dialogTableVisible = false;
      that.formInline.mobile = "";
      that.formInline.vip = "";
      that.formInline.column_ary = [];
      that.formInline.course_id = "";
      that.formInline.is_plus = 0;
      that.formInline.is_pack = 1;
      that.course_ary = [];
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.formInline;
        var url = "/setDouyin";
        that.axios.post(url, formData).then(() => {
          that.$message.success("添加成功!");
          that.formInline.mobile = "";
          that.getList();
        });
      });
    },

    submitClear() {
      const that = this;
      that.formInline.mobile = "";
      that.formInline.vip = "";
      that.formInline.column_id = "";
      that.formInline.course_id = "";
      that.formInline.is_plus = 0;
      that.formInline.is_pack = 1;
      that.course_ary = [];
      that.getList();
    },

    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },

    active_item(ids) {
      let that = this;
      this.$confirm("确认要帮用户激活此课程吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios.post("/setActiveCourse", { id: ids }).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            that.getList();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        });
      });
    },

    del_item(ids) {
      let that = this;
      this.$confirm("确认要移除此激活信息吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios.post("/setDelDouyin", { id: ids }).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            that.getList();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        });
      });
    },

    onChangeType(e) {
      console.log(e);
      if (e == 2) {
        this.GirdUrl = "/getPagePackage";
      } else {
        this.GirdUrl = "/getPageCourse";
      }
      this.is_pack = e;
      this.formInline.course_id = "";
      this.course_ary = [];
      this.pageGrid = 1;
      this.getGridData();
    },

    getGridData() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page_grid");
      that.pageGrid = curr_page ? curr_page - 0 : that.pageGrid;
      formData.page = that.pageGrid;
      formData.limit = that.limit;
      formData.column_id = that.formInline.column_id;
      formData.course_id = that.formInline.course_id;
      formData.column_ary = that.formInline.column_ary;
      formData.pattern_id = that.search.pattern_id;
      formData.keys = that.search.keys;
      that.axios.post(that.GirdUrl, formData).then((res) => {
        if (res) {
          console.log(res);
          that.gridData = res.data.data;
          that.countGrid = res.data.total;
          that.pageSize = res.data.per_page;
          that.pageGrid = curr_page ? curr_page : that.pageGrid;
          curr_page ? sessionStorage.removeItem("curr_page_grid") : "";
          that.loading = false;
        }
      });
    },

    handleChange(value) {
      console.log(value.length);
      if (value.length >= 1) {
        this.formInline.column_id = value[0][1];
      } else {
        this.formInline.column_id = "";
      }
      this.getGridData();
    },

    getColumn() {
      var that = this;
      var user = JSON.parse(sessionStorage.getItem('access-users'));
      that.axios.post("/getColumn", {
        uid: user.id
      }).then((res) => {
        if (res) {
          that.LmColumn = res.data;
        }
      });
    },

    getCoursePattern() {
      var that = this;
      that.axios.post("/getCoursePattern").then((res) => {
        if (res) {
          that.pattern = res.data;
        }
      });
    },

    setOpenCourse(e) {
      var that = this;
      that.axios
        .post("/setOpenCourse", { id: that.uid, course_id: e.id })
        .then((res) => {
          that.getList();
          that.$message({
            type: "success",
            message: res.msg,
          });
        });
    },

    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var user = JSON.parse(sessionStorage.getItem('access-users'));
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.uid = user.id;
      formData.limit = that.limit;
      formData.keys = that.searchs.mobile;
      that.axios.post("/getDouyin", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
    /**
     * 返回
     */
    back() {
      this.$router.push("/users/index");
    },
  },
};
</script>
<style></style>